exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comp-user-holder .userImage{height:135px;width:135px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.comp-user-holder .avatar{border-radius:50%;height:135px;width:135px;position:relative}.comp-user-holder .user-initials{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-size:70px;font-weight:700}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Widgets/CompetitionWidgets/CompetitionBestTodayWidget.scss
 ** module id = 769
 ** module chunks = 0
 **/